import React, { useState, useRef } from 'react';
import { MdDelete, MdSave } from 'react-icons/md';
import API from '../services/api';
import { useGeneralMsgUpdate } from '../context/GenralMsgContext';

const titleOptions = [
  "First Meeting",
  "Personal Interests",
  "Family Details",
  "Professional Background",
  "Follow-Up Items",
  "Future Plans",
];

const titleColors = [
  "#D0A8F0", "#264653", "#E76F51", "#2A9D8F", "#F77F00", "#A8DADC"
];

const getBorderColor = (noteTitle) => {
  if (!noteTitle) return "#0A66C2";
  const index = titleOptions.indexOf(noteTitle.trim());
  return index !== -1 ? titleColors[index] : "#0A66C2";
};

const NoteCard = ({ note, onUpdate, onDelete }) => {
  const setGeneralMsg = useGeneralMsgUpdate();
  const [title, setTitle] = useState(note.title || '');
  const [content, setContent] = useState(note.noteContent || '');
  const [isEditing, setIsEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const textareaRef = useRef(null);

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await API.put(`/notes/${note._id}`, {
        title,
        noteContent: content,
      });
      onUpdate(res.data.note);
      setGeneralMsg('Note updated!', 'success');
      setIsEditing(false);
    } catch (err) {
      setGeneralMsg('Failed to update note', 'error');
    }
    setSaving(false);
  };

  const handleDelete = async () => {
    if (!window.confirm('Delete this note?')) return;
    setDeleting(true);
    try {
      await API.delete(`/notes/${note._id}`);
      onDelete(note._id);
      setGeneralMsg('Note deleted', 'success');
    } catch (err) {
      setGeneralMsg('Failed to delete note', 'error');
    }
    setDeleting(false);
  };

  return (
    <div
      className="note-item"
      style={{
        // borderLeft: `.3rem solid ${getBorderColor(title)}`,
        background: '#1B1F23',
        color: '#dedfdf',
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        maxWidth: '100%',
        margin: 0,
        marginBottom: 0,
        position: 'relative',
        fontSize: '0.97rem'
      }}
    >
      <div className="note-header" style={{
        borderColor: getBorderColor(title),
        background: '#212427',
        borderRadius: '.5rem .5rem 0 0',
        padding: '.7rem 1.2rem .7rem 1rem',
        gap: '.5rem'
      }}>
        <div className="note-title-container" style={{ flex: 1 }}>
          <input
            type="text"
            value={title}
            onChange={e => { setTitle(e.target.value); setIsEditing(true); }}
            placeholder="Give it a headline"
            className="note-title"
            maxLength={200}
            list="title-suggestions"
            style={{
              width: '100%',
              background: 'none',
              color: '#dedfdf',
              fontSize: '1.1rem'
            }}
          />
          <datalist id="title-suggestions">
            {titleOptions.map((suggestion, idx) => (
              <option key={idx} value={suggestion} />
            ))}
          </datalist>
        </div>
        <button
          className="delete-note-btn"
          onClick={handleDelete}
          disabled={deleting}
          title="Delete this note"
          style={{ fontSize: '1.2rem' }}
        >
          <MdDelete />
        </button>
      </div>
      <textarea
        ref={textareaRef}
        className="note-textarea"
        value={content}
        onChange={e => { setContent(e.target.value); setIsEditing(true); }}
        placeholder="Write your note here..."
        maxLength={5000}
        style={{
          color: '#dedfdf',
          width: '100%',
          minHeight: 40,
          resize: 'vertical',
          padding: '.7rem 1.2rem 0',
          background: 'none',
          border: 'none',
          outline: 'none',
          fontSize: '0.95rem'
        }}
      />
      <div className="note-meta" style={{padding: '.7rem0 1.2rem 0', fontSize: '.85rem', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '1.2rem'}}>
        <span className="note-char-count" style={{alignSelf: 'end', color: 'gray'}}>{content.length}/5000</span>
        <span className="note-updated-at">
          {note.updatedAt ? `Updated at: ${new Date(note.updatedAt).toLocaleString()}` : 'Updated at: _'}
        </span>
      </div>
      {/* LinkedIn profile link */}
      {note.profileUsername && (
        <div style={{padding: '0 .7rem .7rem 1.2rem', fontSize: '.85rem'}}>
          <a
            href={`https://www.linkedin.com/in/${note.profileUsername}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#dedfdf', textDecoration: 'underline', wordBreak: 'break-all' }}
          >
            View {note.profileUsername} Profile
          </a>
        </div>
      )}
      {isEditing && (
        <button
          className="btn"
          style={{ margin: '.7rem auto .7rem', display: 'block', fontSize: '.95rem', padding: '.4rem 1.2rem' }}
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? 'Saving...' : <><MdSave /> Save</>}
        </button>
      )}
    </div>
  );
};

export default NoteCard;
